"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bsp = void 0;
class Bsp {
    constructor(name, entities, textures, models, lightmap) {
        this.skies = [];
        this.sprites = {};
        this.name = name;
        this.entities = entities;
        this.textures = textures;
        this.models = models;
        this.lightmap = lightmap;
    }
}
exports.Bsp = Bsp;
